import {
  Box,
  Button,
  DialogActions,
  DialogTitle,
  Modal,
  Typography
} from '@mui/material';
import { utf8SafeDecode } from '../../shared/UtilFunctions';

export default function CommentsPopup(props) {
  const { handleCancel, showModal, supplier } = props;

  let comments = supplier.comments.replaceAll(/[^\x20-\x7E]+/g, '');
  comments = comments.replaceAll(/(<([^</>]+)>)/gi, ' ');

  return (
    <Modal open={showModal} onClose={handleCancel}>
      <Box
        sx={(theme) => ({
          width: 'min(40rem, 92vw)',
          maxHeight: '90vh',
          overflowY: 'auto',
          mx: 'auto',
          mt: '8vh',
          bgcolor: 'background.paper',
          borderRadius: theme.fuel6Tokens.JddcRadiusSmall,
          boxShadow: theme.shadows[24]
        })}
      >
        <DialogTitle>
          <Box>
            <Typography variant="h2" gutterBottom>
              Supplier Comments
            </Typography>
            <Typography>
              {supplier.supplierNumber + ' - ' + supplier.supplierName}
            </Typography>
          </Box>
        </DialogTitle>
        {supplier && (
          <Box p={3}>
            <Typography fontWeight="bold">Comment</Typography>
            <Typography>{utf8SafeDecode(comments)}</Typography>
          </Box>
        )}
        <ModalActions>
          <Button variant="secondary" onClick={handleCancel}>
            Close
          </Button>
        </ModalActions>
      </Box>
    </Modal>
  );
}
